<template>
  <div v-loading="isLoading">
    <el-table
      :data="surcharges"
      stripe
    >
      <el-table-column
        label="Name"
        prop="rate_surcharge"
        :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-'"
      />
      <el-table-column
        label="Short"
        prop="rate_surcharge"
        :formatter="(row, col, cellValue) => cellValue ? (cellValue.short || '-') : '-'"
      />
      <el-table-column
        label="Value"
        prop="rate_surcharge"
        :formatter="(row, col, cellValue) => cellValue ? ('$' + (cellValue.sell_value ? Number(cellValue.sell_value).toFixed(2) : '-')) : '-'"
      />
      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editSurcharge(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteSurcharge(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- Edit Form -->
    <InvoiceSurchargeEditForm
      ref="editForm"
      :account-id="accountId"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import InvoiceSurchargeEditForm from '@/components/Application/Manage/Account/InvoiceSurchargeEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'
export default {
  components: {
    InvoiceSurchargeEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      surcharges: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'account_invoicesurcharge')
    },
    canDelete () {
      return this.$user.can(DELETE, 'account_invoicesurcharge')
    }
  },
  created () {
    this.loadTable()
  },
  mounted () {
    this.actions = [
      {
        hidden: this.$user.cannot(CREATE, 'account_invoicesurcharge'),
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
          this.$refs.editForm.surcharge = {}
          this.$refs.editForm.isShow = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.invoicesurcharge.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.include = ['rate_surcharge']
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'surcharge_short:asc'
      })
        .then(res => {
          this.surcharges = res
          this.total = res.total
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editSurcharge (index, row) {
      this.$refs.editForm.surcharge = row
      this.$refs.editForm.isShow = true
    },
    deleteSurcharge (index, row) {
      this.$confirm('Are you sure to delete this invoice surcharge?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
